// extracted by mini-css-extract-plugin
export default {"header":"App_header__eTa8O","msftLogo":"App_msftLogo__YrX9v","headerDivider":"App_headerDivider__6bt1Q","headerTitle":"App_headerTitle__XrkLD"};